import { View } from '@ui/atoms';
import { useCallback, useState } from 'react';
import { FeedDefaultProps, FeedPropTypes } from '@ui/organisms/Feed/FeedPropTypes';
import FeedItem from '@ui/organisms/Feed/FeedItem';
import { InView } from 'react-intersection-observer';

const BATCH_SIZE = 20;

function Feed({
  items = FeedDefaultProps.items,
  header = FeedDefaultProps.header,
  empty = FeedDefaultProps.empty,
  sx = FeedDefaultProps.sx,
}) {
  const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);

  const loadMore = useCallback(() => {
    setVisibleCount((prev) => Math.min(prev + BATCH_SIZE, items.length));
  }, [items.length]);

  const visibleItems = items.slice(0, visibleCount);

  return (
    <View sx={sx}>
      {header}
      {visibleItems.length > 0
        ? visibleItems.map((item, index) => {
            const isLastItem = index === visibleItems.length - 1;
            return (
              <InView
                key={item.id}
                onChange={(inView) => {
                  if (inView && isLastItem && visibleCount < items.length) {
                    loadMore();
                  }
                }}
                threshold={0.5}
              >
                {({ ref }) => (
                  <div ref={ref}>
                    <FeedItem visible id={item.id} type={item.type} />
                  </div>
                )}
              </InView>
            );
          })
        : empty}
    </View>
  );
}

Feed.propTypes = FeedPropTypes;

export default Feed;
